var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCorporates(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.66663 19.1515H18.3333",
    stroke: "#F1F1F1",
    strokeWidth: 1.25,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15 8.31818H11.6666C9.59829 8.31818 9.16663 8.74984 9.16663 10.8182V19.1515H17.5V10.8182C17.5 8.74984 17.0683 8.31818 15 8.31818Z",
    stroke: "#F1F1F1",
    strokeWidth: 1.25,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 19.1515H2.5V4.98483C2.5 2.9165 2.93167 2.48483 5 2.48483H10C12.0683 2.48483 12.5 2.9165 12.5 4.98483V8.31817",
    stroke: "#F1F1F1",
    strokeWidth: 1.25,
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 5.81818H5M2.5 9.15151H5M2.5 12.4848H5",
    stroke: "#F1F1F1",
    strokeWidth: 1.25,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 11.6515H14.1667M12.5 14.1515H14.1667",
    stroke: "#F1F1F1",
    strokeWidth: 1.25,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3334 19.1515V16.6515",
    stroke: "#F1F1F1",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCorporates);
export default __webpack_public_path__ + "static/media/corporates.3c38f5e65b2a5d07548ed7bfc313ce5c.svg";
export { ForwardRef as ReactComponent };